import React from 'react'
import ScheduleCarousel from "./scheduleCarousel";

const PersonCarousel = (props) => {
  return <ScheduleCarousel {...props} type={"person"} />;
    
}

export default PersonCarousel;
